module.exports = __webpack_public_path__ + "img/trolley-icon-success.13e6c75d.png";